import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";

import axios from "./axios";
import "./filters";
import VueHtmlToPaper from "vue-html-to-paper";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import VueClipboard from "vue-clipboard2";
import VueProgressBar from "vue-progressbar";
import PerfectScrollbar from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
import TextareaAutosize from "vue-textarea-autosize";
import Sortable from "vue-sortable";
import Snotify, { SnotifyPosition } from "vue-snotify";
import VCalendar from "v-calendar";
import VueSocketIOExt from "vue-socket.io-extended";
import { io } from "socket.io-client";

const socket = io("http://134.209.250.189:5000/", {
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 3000,
});

Vue.use(VueSocketIOExt, socket);

const options = {
  toast: {
    position: SnotifyPosition.centerTop,
  },
};

Vue.use(Snotify, options);

Vue.config.productionTip = false;

Vue.use(VCalendar);

Vue.use(Sortable);
Vue.use(TextareaAutosize);
Vue.use(PerfectScrollbar);
Vue.use(VueProgressBar, {
  color: "#2196f3",
  failedColor: "red",
  thickness: "4px",
  location: "top",
  autoFinish: false,
});

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

Vue.use(VueHtmlToPaper);
Vue.prototype.$http = axios;

Vue.directive("click-outside", {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
    document.body.addEventListener("touchmove", el.clickOutsideEvent);
  },
  unbind: function(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
    document.body.removeEventListener("touchmove", el.clickOutsideEvent);
  },
});

export default new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
